import { render, staticRenderFns } from "./Findinfo_sns.vue?vue&type=template&id=b6b5332c"
import script from "./Findinfo_sns.vue?vue&type=script&lang=js"
export * from "./Findinfo_sns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports